module.exports = __webpack_public_path__ + "img/icon-2.d64ab4a1.png";